import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {

  constructor(private toastr: ToastrService, private http: HttpClient) { }

  loadScript(scriptUrl: string) {
    let node = document.createElement('script');
    node.src = scriptUrl;
    node.type = 'text/javascript';
    node.async = true;
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  getData(url: string): Observable<any> {
    return this.http.get<any>(url);
  }

  /***
   * see: https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid
   */
  generateUuid() {
    return (<any>[1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, (c: any) =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

  isHTML(str: any) {
    var a = document.createElement('div');
    a.innerHTML = str;

    for (var c = a.childNodes, i = c.length; i--; ) {
      if (c[i].nodeType == 1) return true;
    }

    return false;
  }

  containsSubstring(string: string, substrings: any) {
    for (const substring of substrings) {
      if (string.includes(substring)) {
        return true;
      }
    }
    return false;
  }
}
